<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <UserProperty
      @dataAvailable="
        data => {
          userData = data || {}
        }
      "
    />

    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="text-4xl title-color">Dashboard</div>
      <div class="flex gap-12 items-center">
        <!-- <div class="w-[30rem] flex items-center relative">
          <input
            type="text"
            class="w-full pl-12 py-4 rounded-2xl"
            placeholder="Rechercher"
          />
          <div class="w-6 h-6 text-[#30225C] absolute left-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div> -->
        <router-link class="flex h-12 w-12 rounded-full overflow-hidden" to="/preferences#personnal">
          <img
            :src="
              userData?.metaData?.rawUser?.metadata?.pictureUrl ||
              userData.profilePictureUrl
            "
            class="w-full h-full"
            alt=""
          />
        </router-link>
      </div>
    </div>
    <div class="py-2"></div>
    <div class="hidden">
      <div class="flex w-full border-b">
        <div
          class="flex gap-2 p-2 pb-4 relative justify-center cursor-pointer rounded-lg px-4"
          v-for="(tab, i) in tabs"
          :key="i"
          @click="activeTab = tab.id"
        >
          <div class="w-6 h-6">
            <img src="" alt="" class="w-full h-full" />
          </div>
          <div>{{ tab.name }}</div>
          <div
            :class="{
              'w-full bg-primary': activeTab == tab.id,
              'w-0 bg-transparent': activeTab !== tab.id,
            }"
            class="duration-300 absolute bottom-0 rounded-t-xl h-1"
          ></div>
        </div>
      </div>
    </div>
    <div class="py-4"></div>
    <div>
      <DashboardTopBoxes />
    </div>
    <div class="py-4"></div>
    <div>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div class="relative md:col-span-2">
          <div class="w-full h-full absolute bg-white rounded-content-md"></div>
          <div class="relative w-full h-full p-4">
            <div
              class="flex gap-4 flex-col md:flex-row justify-between items-center"
            >
              <div class="title-color text-lg md:text-xl">
                Transactions & Commandes
              </div>
              <div class="flex gap-4">
                <button
                  v-for="(duration, i) in durations"
                  :key="i"
                  class="rounded-full border px-4 py-1 duration-300"
                  :class="{
                    'bg-primary-1000 text-white': activeDuration == duration.id,
                  }"
                  @click="activeDuration = duration.id"
                >
                  {{ duration.name }}
                </button>
              </div>
            </div>
            <div class="py-2"></div>
            <PlatformStat :period="durations[activeDuration]" />
          </div>
        </div>
        <div class="relative col-span-1">
          <div class="w-full h-full absolute bg-white rounded-content-md"></div>
          <div class="relative w-full h-full p-4">
            <div class="flex justify-between items-center">
              <div class="title-color text-xl">Paiements</div>
            </div>
            <div class="py-2"></div>
            <PaymentsStats />
          </div>
        </div>
      </div>
    </div>
    <div class="py-4"></div>
    <div>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div class="relative md:col-span-2">
          <div class="w-full h-full absolute bg-white rounded-content-md"></div>
          <div class="relative w-full h-full p-4">
            <div class="flex justify-between items-center">
              <div class="title-color text-xl">Derniers paiements</div>
            </div>
            <div class="py-2"></div>
            <LastPayments />
          </div>
        </div>
        <div class="relative md:col-span-1">
          <div class="w-full h-full absolute bg-white rounded-content-md"></div>
          <div class="relative w-full h-full p-4">
            <div class="flex justify-between items-center">
              <div class="title-color text-xl">Derniers clients</div>
            </div>
            <div class="py-2"></div>
            <LastCustomers />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LastCustomers from '@/components/appData/LastCustomers.vue'
import LastPayments from '@/components/appData/LastPayments.vue'
import PaymentsStats from '@/components/stats/PaymentsStats.vue'
import DashboardTopBoxes from '@/components/stats/DashboardTopBoxes.vue'
import PlatformStat from '@/components/stats/PlatformStat.vue'
import UserProperty from '@/components/user/UserProperty.vue'

export default {
  name: 'homeComponent',
  components: {
    PlatformStat,
    PaymentsStats,
    LastCustomers,
    LastPayments,
    UserProperty,
    DashboardTopBoxes,
  },
  data() {
    return {
      userData: {},
      eventsIds: [],
      tabs: [
        { name: 'Overview', id: 'overview' },
        { name: 'Medical Report', id: 'medicalReport' },
        { name: 'Patients Overview', id: 'tab3' },
        { name: 'Diagnose', id: 'tab4' },
      ],
      activeTab: 'home',
      durations: {

        paymentStatsYear: { name: '12 Mois', formatId: 'month', id: 'paymentStatsYear' },
        paymentStatsMonth: { name: '30 Jours', formatId: 'day', id: 'paymentStatsMonth' },
        paymentStatsWeek: { name: '14 Jours', formatId: 'day', id: 'paymentStatsWeek' },
        // { name: '1 Mois', id: '1month' },
      },
      activeDuration: 'paymentStatsYear',
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {},
  methods: {},
}
</script>
